import { MutationHookOptions, useMutation } from '@apollo/client';

import { CREATE_USER } from './mutations';

export const useCreateUser = (options?: MutationHookOptions) => useMutation(CREATE_USER, options);
